export const securitySetup = {
  junior: {
    requirements: [
      { name: 'User Data Privacy Training', description: 'Complete comprehensive training on user data privacy and protection', priority: 'high' },
      { name: 'Research Ethics Certification', description: 'Complete research ethics and participant consent training', priority: 'high' },
      { name: 'Secure Data Handling', description: 'Learn secure practices for collecting and storing user research data', priority: 'high' },
      { name: 'Tool Security Configuration', description: 'Secure configuration of research tools and platforms', priority: 'medium' }
    ],
    procedures: [
      { step: 'Complete privacy training', command: 'Complete company privacy and GDPR training for researchers' },
      { step: 'Set up secure data storage', command: 'Configure secure cloud storage for research data with encryption' },
      { step: 'Enable 2FA on research tools', command: 'Enable two-factor authentication on all research platforms' },
      { step: 'Review participant consent procedures', command: 'Understand and implement proper consent collection and management' }
    ]
  },
  mid: {
    requirements: [
      { name: 'Advanced Data Protection', description: 'Implement advanced data protection measures for research data', priority: 'high' },
      { name: 'Cross-border Data Compliance', description: 'Ensure compliance with international data protection regulations', priority: 'high' },
      { name: 'Research Tool Security Audit', description: 'Conduct security audits of research tools and vendors', priority: 'medium' },
      { name: 'Participant Data Anonymization', description: 'Implement proper data anonymization and pseudonymization techniques', priority: 'medium' }
    ],
    procedures: [
      { step: 'Implement data governance', command: 'Set up comprehensive data governance framework for research' },
      { step: 'Conduct security assessments', command: 'Regular security assessment of research tools and processes' },
      { step: 'Set up data retention policies', command: 'Implement automated data retention and deletion policies' },
      { step: 'Create incident response plan', command: 'Develop incident response procedures for data breaches' }
    ]
  },
  senior: {
    requirements: [
      { name: 'Research Security Strategy', description: 'Define comprehensive security strategy for research operations', priority: 'high' },
      { name: 'Privacy by Design Implementation', description: 'Implement privacy by design principles in all research activities', priority: 'high' },
      { name: 'Regulatory Compliance Framework', description: 'Establish compliance framework for multiple jurisdictions', priority: 'high' },
      { name: 'Security Culture Development', description: 'Foster security-conscious culture within research teams', priority: 'medium' }
    ],
    procedures: [
      { step: 'Develop security framework', command: 'Create comprehensive security framework for research operations' },
      { step: 'Implement privacy controls', command: 'Design and implement privacy controls across all research processes' },
      { step: 'Establish compliance monitoring', command: 'Set up continuous compliance monitoring and reporting' },
      { step: 'Security awareness program', command: 'Develop security awareness and training program for research teams' }
    ]
  }
};
